export default __webpack_public_path__ + "static/media/icon-green-tick.22a250c6.svg";